import React from "react";

export function Logo({ variant = "full", className = "" }) {
  // Official ARVEN visual identity.
  // Crops available in /public/brand:
  //  - arven-logo.png      : compact ARVEN + CUISINES wordmark (best for header)
  //  - arven-logo-full.png : ARVEN + CUISINES + tagline (richer, for footer/large)
  //  - arven-mark.png      : the gold "A" mark only (icon)
  if (variant === "mark") {
    return (
      <img
        src="/brand/arven-mark.png"
        alt="ARVÈN"
        className={`h-9 w-auto ${className}`}
        data-testid="arven-logo-mark"
      />
    );
  }
  if (variant === "tagline") {
    return (
      <img
        src="/brand/arven-logo-full.png"
        alt="ARVÈN Cuisines — L'art de concevoir votre quotidien"
        className={`h-auto w-48 md:w-60 ${className}`}
        data-testid="arven-logo-full"
      />
    );
  }
  return (
    <img
      src="/brand/arven-logo-header.png"
      alt="ARVÈN Cuisines"
      className={`h-12 md:h-14 w-auto ${className}`}
      style={{ minWidth: 140 }}
      data-testid="arven-logo"
    />
  );
}
